function SvgComponent(props: any) {
    return (
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
            d="M9.167 3.333h-3.5c-1.4 0-2.1 0-2.635.273a2.5 2.5 0 00-1.093 1.092c-.272.535-.272 1.235-.272 2.635v7c0 1.4 0 2.1.272 2.635a2.5 2.5 0 001.093 1.093c.534.272 1.235.272 2.635.272h7c1.4 0 2.1 0 2.635-.272a2.5 2.5 0 001.092-1.093c.273-.534.273-1.234.273-2.635v-3.5m-10 2.5h1.395c.408 0 .612 0 .803-.046.17-.04.333-.108.482-.2.168-.102.312-.246.6-.535l7.97-7.969a1.768 1.768 0 00-2.5-2.5l-7.97 7.97c-.288.288-.432.432-.535.6-.091.15-.158.312-.2.482-.045.191-.045.395-.045.803v1.395z"
            stroke="#0A756F"
            strokeWidth={1.66667}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
      </svg>
    )
}
  
  export default SvgComponent